import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { onResponseCreateEmployee } from "./helpers";

const createEmployee = async (data: CreateEmployeeReqT) => {
  const { role, ...params } = data;
  return axios.post(Routes.CREATE_EMPLOYEE, { ...params, role_id: role.id });
};

export const useCreateEmployee = () =>
  useMutation({
    mutationKey: [Keys.CREATE_EMPLOYEE],
    mutationFn: createEmployee,
    onSettled: onResponseCreateEmployee,
    cacheTime: Infinity,
  });
